// extracted by mini-css-extract-plugin
module.exports = {"modalFooterButtons":"ShippingFormFormEditionModal_modalFooterButtons__1YUTb"};